<script setup>
import ContratDeRemplacementForm from '@/components/contrat/contrat-de-remplacement-form.vue'
import SToolbar from '@/components/global/s-toolbar.vue'
</script>

<template>
  <v-dialog v-model="showDialog" max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn class="mr-2" color="success" fab outlined x-small v-on="on">
        <v-icon color="success">fa-people-arrows</v-icon>
      </v-btn>
    </template>
    <v-card v-if="loaded">
      <s-toolbar :text="'Remplacer ' + employeRemplace.nomComplet" create @close="close()" />
      <v-card-text>
        <contrat-de-remplacement-form
          ref="contratDeRemplacementForm"
          v-model="createContratDeRemplacementCommand"
          :employeRemplace="employeRemplace"
          :minDateRemplacement="conges.dateDebut"
          :maxDateRemplacement="conges.dateFin"
          @formValidity="(v) => (this.contratFormValid = v)"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="showDialog = false">Annuler</v-btn>
        <v-btn color="success" :disabled="!contratFormValid" @click="dispatchCommand()">Créer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'contrat-de-remplacement-create-dialog',
  props: {
    employeRemplace: {
      type: Object,
      required: true,
    },
    conges: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showDialog: false,
      createContratDeRemplacementCommand: undefined,
      contratFormValid: false,
    }
  },
  computed: {
    loaded() {
      return this.createContratDeRemplacementCommand
    },
  },
  created() {
    this.initialiserCommand()
  },
  methods: {
    ...mapActions({
      createContratDeRemplacement: 'employe/createContratDeRemplacement',
    }),
    close() {
      this.showDialog = false
      this.initialiserCommand()
    },
    initialiserCommand() {
      this.createContratDeRemplacementCommand = {
        type: null,
        dateDebut: this.conges.dateDebut,
        dateFin: this.conges.dateFin,
        remplacantId: null,
        remplaceId: this.employeRemplace.employeId,
        remplaceSurTempsReel: true,
      }
    },
    dispatchCommand() {
      this.createContratDeRemplacement(this.createContratDeRemplacementCommand)
      this.initialiserCommand()
      this.$refs.contratDeRemplacementForm.reset()
      this.close()
    },
  },
}
</script>

<style scoped></style>
